import React, { Component } from 'react';
import { translate } from 'react-i18next';
import ReactGA from 'react-ga';
import Timestamp from '../Timestamp';
import store from '../../store';

class VehicleSpec extends Component {
  backToSearch = () => {
    const { i18n, selectedFamily, backToSearch } = this.props;
    ReactGA.event({
      category: i18n.language,
      action: selectedFamily,
      label: 'Start New Search',
    });
    backToSearch();
  };

  render() {
    const { t, equipment, backToSearch } = this.props;
    const reg = store.getState().content.reg;

    return (
      <section className="spec">
        <Timestamp now={new Date()} />
        <p>{t('vehicle_spec.recommendation')}</p>
        {backToSearch && (
          <a onClick={this.backToSearch} className="button">
            {t('vehicle_spec.new_search')}
          </a>
        )}
        <ul>
          {reg && (
            <li>
              <span className="heading">{t('vehicle_spec.reg')}</span>{' '}
              <span className="number-plate">{reg}</span>
            </li>
          )}
          <li>
            <span className="heading">{t('vehicle_spec.manufacturer')}</span>{' '}
            {equipment.model.manufacturer
              ? equipment.model.manufacturer
              : t('vehicle_spec.not_applicable')}
          </li>
          <li>
            <span className="heading">{t('vehicle_spec.model')}</span>{' '}
            {equipment.model.display_name_short
              ? equipment.model.display_name_short
              : t('vehicle_spec.not_applicable')}
          </li>
          <li>
            <span className="heading">{t('vehicle_spec.year')}</span>{' '}
            {equipment.model.year_from
              ? equipment.model.year_from
              : t('vehicle_spec.not_applicable')}
          </li>
          <li>
            <span className="heading">{t('vehicle_spec.engine_size')}</span>{' '}
            {equipment.model.displacement
              ? equipment.model.displacement
              : t('vehicle_spec.not_applicable')}
          </li>
          <li>
            <span className="heading">{t('vehicle_spec.fuel_type')}</span>{' '}
            {equipment.model.fuel ? equipment.model.fuel : t('vehicle_spec.not_applicable')}
          </li>
        </ul>
      </section>
    );
  }
}

export default translate('translations')(VehicleSpec);



// WEBPACK FOOTER //
// ./src/components/results/vehicleSpec.js